export const bestSelling = [
    {
        img: 'https://ik.imagekit.io/mctozv7td/Mirpur%20Jewelers/meenapic/IMG-20240403-WA0013.jpg?updatedAt=1712146106550',
        title: "Gemstone Pendant Chain",
    },
    {
        img: 'https://ik.imagekit.io/mctozv7td/Mirpur%20Jewelers/meenapic/IMG-20240401-WA0019.jpg?updatedAt=1712146097595',
        title: "Eternal Ruby Stud",
    },  
    {
        img: 'https://ik.imagekit.io/mctozv7td/Mirpur%20Jewelers/meenapic/IMG-20240401-WA0023.jpg?updatedAt=1712146097910',
        title: "Brilliant Stylish Earrings",
    },
    {
        img: 'https://ik.imagekit.io/mctozv7td/Mirpur%20Jewelers/meenapic/WhatsApp%20Image%202024-04-03%20at%2016.41.47_6312142d.jpg?updatedAt=1712146106850',
        title: "Inspired Round Hooks",
    },
]